import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ARViewEntryPage } from './ar-view-entry.page';
import { PagesModule } from '../pages.module';

const routes: Routes = [
  {
    path: '',
    component: ARViewEntryPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ARViewEntryPage]
})
export class ARViewEntryPageModule { }
